import { setStartDate, setEndDate } from '@/components/common/common_js'
import { coachName } from './common'

// 转译数据
export const translateData = (data, clientData, stageData, originData, belongData, sessionData, allSessionData, startDate, endDate, selectVal) => {
  const tempStageData = stageData
  const tempOriginData = originData
  const tempBelongData = belongData
  const tempClientData = clientData

  const tempStartDate = setStartDate(startDate)
  const tempEndDate = setEndDate(endDate)
  const tempSelectVal = selectVal

  let tempData = []

  let tempTotalWxClient = 0
  let tempTotalStage = {}
  let tempTotalCoachStage = {}
  let tempTotalServiceClient = 0

  // 筛选符合条件的客户
  for (const item of data) {
    const tempOriginItem = tempOriginData.filter(i => i.id === item.origin)
    const tempRelationData = tempClientData.filter(i => i.id === item.relation)

    let tempOriginName
    let tempBelongName

    if (tempOriginItem && tempOriginItem.length > 0) {
      tempOriginName = tempOriginItem[0].name

      const tempBelongItem = tempBelongData.filter(i => i.id === tempOriginItem[0].belong)

      if (tempBelongItem && tempBelongItem.length > 0) tempBelongName = tempBelongItem[0].name
      else tempBelongName = '/'
    } else {
      tempOriginName = '/'
      tempBelongName = '/'
    }

    const tempTranslateRelationData = []
    for (const itemRela of tempRelationData) {
      const tempRelationOrigin = tempOriginData.filter(i => i.id === itemRela.origin)
      tempTranslateRelationData.push({ ...itemRela, originName: tempRelationOrigin && tempRelationOrigin.length > 0 ? tempRelationOrigin[0].name : '/' })
    }

    const tempSessionData = sessionData[item.id]
    const tempDataItem = {
      ...item,
      originName: tempOriginName,
      belongName: tempBelongName,
      select: getNeedClient(item, tempStartDate, tempEndDate),
      stages: [],
      relationData: tempTranslateRelationData
    }

    // 当前客户的阶段数据、阶段统计数据
    for (const stageItem of tempStageData) {
      let tempClientSessionData = tempSessionData && tempSessionData.length ? tempSessionData.filter(i => i.stageId === stageItem.id) : []
      tempClientSessionData = tempClientSessionData.length > 0 ? tempClientSessionData[0] : null

      if (tempClientSessionData) {
        const isNeedStageSession = getNeedStageSession(tempClientSessionData, tempStartDate, tempEndDate, tempSelectVal)
        tempDataItem['stages'].push({ ...tempClientSessionData, select: isNeedStageSession })

        if (isNeedStageSession) {
          if (!tempTotalStage[stageItem.id]) tempTotalStage[stageItem.id] = 0
          tempTotalStage[stageItem.id] = tempTotalStage[stageItem.id] + 1

          if (isCoach(tempClientSessionData)) {
            if (!tempTotalCoachStage[stageItem.id]) tempTotalCoachStage[stageItem.id] = 0
            tempTotalCoachStage[stageItem.id] = tempTotalCoachStage[stageItem.id] + 1
          }
        }
      } else tempDataItem['stages'].push({ clientId: item.id, content: '/', creatAt: '/', id: stageItem.id, isActive: 1, makeAt: '/', stageId: stageItem.id, select: false })
    }

    tempData.push(tempDataItem)

    if (tempDataItem.select) tempTotalWxClient++
    tempTotalServiceClient += getTotalServiceClient(tempDataItem, allSessionData, stageData)
  }

  tempData = tempData.sort((a, b) => b.createdAt - a.createdAt)

  return {
    clientSession: tempData,
    totalWxClient: tempTotalWxClient,
    totalServiceClient: tempTotalServiceClient,
    totalStage: tempTotalStage,
    totalWorkTime: getTotalWorkTime(tempTotalStage, stageData),
    totalCoachWorkTime: getTotalCoachWorkTime(tempTotalCoachStage, stageData)
  }
}

// 获取客户状态
export const getClientStatusVal = function (status) {
  let data = ''
  let tag = ''

  switch (status) {
    case 0:
      data = '已失效'
      tag = 'invaild'
      break
    case 1:
      data = '已完成'
      tag = 'success'
      break
    case 2:
      data = '进行中'
      tag = 'planning'
      break
    default:
      data = '进行中'
      tag = 'planning'
      break
  }

  return {
    status: data,
    tag: tag
  }
}

// 获取选中的客户
export const getNeedClient = function (v, startDate, endDate) {
  const tempStartDate = startDate
  const tempEndDate = endDate
  const tempCreatAt = v.creatAt * 1000

  const isNeedTime = tempStartDate && tempEndDate && tempCreatAt >= new Date(tempStartDate).getTime() && tempCreatAt <= new Date(tempEndDate).getTime()

  return isNeedTime
}

// 获取选中的阶段
export const getNeedStageSession = function (v, startDate, endDate, selectVal) {
  const tempStartDate = startDate
  const tempEndDate = endDate
  const tempMakeAt = v.makeAt * 1000
  const tempSelectVal = (isCoach(v) && selectVal === coachName) || (selectVal === 'all')

  const isNeedTime = tempStartDate && tempEndDate && tempMakeAt >= new Date(tempStartDate).getTime() && tempMakeAt <= new Date(tempEndDate).getTime() && tempSelectVal
  const isNeedStatus = v.status && v.status === 1 // 已完成

  return isNeedTime && isNeedStatus
}

// 获取咨询服务新增
export const getTotalServiceClient = function (v, allSessionData, stageData) {
  const envModule = process.env.ENV_MODULE
  const tempAllClientSessionData = allSessionData
  let totalStage = 0

  let needStageData = envModule === 'development' ? [6, 7] : [6, 7]
  needStageData = stageData.filter(i => needStageData.includes(i.sort))

  if (needStageData) {
    needStageData = needStageData.map(i => i.id)

    // 当前客户已完成的阶段
    const sessionStageCompleted = tempAllClientSessionData.filter(i => i.clientId === v.id && needStageData.includes(i.stageId) && i.status === 1)

    if (sessionStageCompleted && sessionStageCompleted.length > 0) {
      // 筛选需要统计的阶段（统计逻辑：保单整理和收集资料已完成，只统计一次，优先统计时间最早的）
      let tempSelected = {}

      for (const item of v.stages) {
        if (item.makeAt > 1000 && needStageData.includes(item.stageId) && item.status === 1) {
          if (tempSelected.id) {
            totalStage = 0

            if (tempSelected.select && item.select) totalStage = 1
            else if (tempSelected.select && tempSelected.makeAt < item.makeAt) totalStage = 1
            else if (item.select && item.makeAt < tempSelected.makeAt) totalStage = 1
          } else {
            tempSelected = { ...item }
            if (item.select) totalStage = 1
          }
        }
      }

      if (totalStage === 1) console.log('++----咨询服务新增统计', v.name)
    }
  }

  return totalStage
}

// 获取工作时长
export const getTotalWorkTime = function (data, stageData) {
  const tempStageData = stageData

  let totalTime = 0

  for (const item of tempStageData) {
    const tempVal = data[item.id]
    if (tempVal) totalTime += tempVal * item.duration
  }

  return getTimeFormat(totalTime)
}

// 获取带教时长
export const getTotalCoachWorkTime = function (data, stageData) {
  const tempStageData = stageData

  let totalTime = 0

  for (const item of tempStageData) {
    const tempVal = data[item.id]
    if (tempVal) totalTime += tempVal * item.duration
  }

  return getTimeFormat(totalTime)
}

// 格式化时长
export const getTimeFormat = function (v) {
  return (v / 60).toFixed(2) + 'h'
}

// 阶段状态
export const getStageStatusVal = function (val, makeAt) {
  let tempVal = ''
  let tempColor = ''
  let tempBgColor = ''

  switch (val) {
    case 0:
      tempVal = '已终止'
      tempColor = '#D73535'
      tempBgColor = '#FFDBDD'
      break
    case 1:
      tempVal = '已完成'
      tempColor = '#5BBB2B'
      tempBgColor = '#F1FAEB'
      break
    case 2:
      tempVal = '未开始'
      tempColor = '#E48527'
      tempBgColor = '#FFF2DB'
      break
    default:
      if (new Date(makeAt).getTime()) {
        tempVal = '待定'
        tempColor = '#333333'
        tempBgColor = '#F0F0F0'
      }
      break
  }

  return {
    val: tempVal,
    color: tempColor,
    bgColor: tempBgColor
  }
}

// 设置需要的阶段
export const setNeedStage = function () {
  const envModule = process.env.ENV_MODULE
  const needStageData = envModule === 'development' ? [6, 7, 9, 12] : [6, 7, 9, 12]
  return needStageData
}

// 转义用户数据
export const translateUserData = function (data) {
  let tempDataA = data.filter(i => i.sort !== null)
  let tempDataB = data.filter(i => i.sort === null)

  tempDataA = tempDataA.sort((a, b) => a.sort - b.sort)

  return [].concat(tempDataA, tempDataB)
}

// 转译咨询师类型
export const translateConsultTypeData = function (data) {
  let tempData = {}

  if (data) {
    for (const item of data) {
      tempData[item.role] = item.name
    }
  }

  tempData['other'] = '其它'

  return tempData
}

// 用户是否有效
export const isConsultStatus = function (data) {
  return data === 1
}

// 用户类型是否为其它
export const isConsultTypeOther = function (data) {
  return data === 'other'
}

// 客户是否带教
export const isCoach = function (data) {
  return data.coach && data.coach === 1
}



// WEBPACK FOOTER //
// ./src/components/page-client/index-client.js